import React from "react";
import privacyPolicyContent from "./PrivacyPolicy.json";
import "./Policies.scss";

export default function PrivacyPolicy() {
  return (
    <div className="privacy-policy-container">
      <div className="privacy-main-heading privacy-heading">
        {privacyPolicyContent.title}
      </div>
      <div className="privacy-heading">{privacyPolicyContent.updated}</div>
      <div
          className="privacy-para intro"
          dangerouslySetInnerHTML={{
            __html: privacyPolicyContent.introduction.replace(
              "Let’s Fundraise Together LLC",
              "<b>Let’s Fundraise Together LLC</b>"
            )
          }}
      ></div>

      {privacyPolicyContent.sections.map((section, index) => (
        <div key={index} className="section">
          <div className="privacy-heading">{`${index + 1}. ${
            section.title
          }`}</div>
          {section.subtitle && (
            <div className="privacy-sub-heading privacy-para">
              {section.subtitle}
            </div>
          )}
          {section.title === "Your Privacy Rights" ? (
  <>
    <ul className="privacy-section-content">
      {section.content.slice(0, 3).map((paragraph, idx) => (
        <li key={idx} className="privacy-para">
          <div>{paragraph}</div>
        </li>
      ))}
    </ul>

    {/* 4th item as plain text */}
    <div className="privacy-para">
      {section.content[3]}
    </div>
  </>
    ) : index <= 3 ? (
      <ul className="privacy-section-content">
        {section.content.map((paragraph, idx) => (
          <li key={idx} className="privacy-para">
            <div>{paragraph}</div>
          </li>
        ))}
      </ul>
    ) : (
      section.content.map((paragraph, idx) => (
        <div key={idx} className="privacy-para">
          {paragraph}
        </div>
      ))
    )}

        </div>
      ))}
    </div>
  );
}
